import React from 'react';
import ActivityCenter from './ActivityCenter';
import Overview from './Overview';
import QuickView from './QuickView';
import './Dashboard.css';
/**
 * @Description This function lets you return Dashboard page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Dashboard() {
    
    return (
        <div className="db-cont">
            <div className="db-left-cont"><QuickView /><Overview /></div>
            <div className="db-right-cont"><ActivityCenter /></div>
        </div>
    );
}
export default Dashboard;